var l={modal:"modal-left-style-module_modal__WE7y4"};export{l as default};
//# sourceMappingURL=modal-left.style.module.scss.js.map
